import Vue from "vue";
import axios from "axios";

axios.defaults.timeout = 60000;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
axios.defaults.headers.common["User-Agent-Platform"] = "pc";
axios.defaults.headers.common["User-Agent-Language"] =
  window.$lang === "en-US" ? "en" : "cn";
axios.defaults.baseURL = "/api/";
// eslint-disable-next-line
axios.defaults.validateStatus = status => status == 200;
axios.interceptors.request.use(
  config => {
    let u = Vue._h.storage.local.get("uinfo");
    if (!Vue._.isEmpty(u)) {
      config.headers.common["AuthToken"] = u.token;
    }
    if (/post/i.test(config.method)) {
      if (!/upload/i.test(config.url) && !/import/i.test(config.url)) {
        config.data = {
          ...config.data,
          _t: Date.parse(new Date()) / 1000
        };
      }
    } else if (/get/i.test(config.method)) {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      };
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  response => {
    if (response.data instanceof ArrayBuffer) {
      const utf8decoder = new TextDecoder();
      const u8arr = new Uint8Array(response.data);
      const temp = utf8decoder.decode(u8arr);
      if (temp.includes("code")) {
        const _res = JSON.parse(temp);
        return Promise.reject(new Error(_res.message || "Error"));
      } else {
        return response;
      }
    } else if (response.data && response.data.code === 401) {
      //\u9002\u914d\u8def\u7531mode\u4e3ahistory\u7684\u60c5\u51b5
      setTimeout(() => {
        if (location.hash) {
          location.replace(
            `/#/login?backurl=${location.hash.replace(/^\/?#/, "")}`
          );
        } else {
          location.replace(
            `/login?backurl=${location.pathname + location.search}`
          );
        }
      }, 0);
      return response;
    } else {
      return response;
    }
  },
  error => {
    return Promise.reject(error);
  }
);

/* eslint-disable */
export default {
  mobileRegister(data, callback) {
    axios
      .post("singleMember/mobileRegister", data)
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  sendVerificationCode(data, callback) {
    axios
      .post("user/sendVerificationCodeRegister", data)
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  picCode(callback) {
    axios
      .post(`user/picCode`)
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getindexnewslist(data, callback) {
    axios
      .get(`index/downloadData`, { params: data })
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getareaList(value, callback) {
    axios
      .get(`static/data/areaList?type=` + value)
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  noticelist(callback) {
    axios
      .get(`index/notice/list?publishAdd=1`)
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getOriginGoodsSpecialList(data, callback) {
    axios
      .get(`ruling/goods/getOriginGoodsSpecialList/${data}`)
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getnewslist(data, callback) {
    axios
      .get(`news/list`, { params: data })
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },

  getTypeList(callback) {
    axios
      .get(`news/getTypeList`)
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getDate(data, callback) {
    axios
      .get("maintenanceRecord/getMaintenanceTime", { params: data })
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getDictData(callback) {
    axios
      .get("statistics/data")
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getSearchDictData(callback) {
    axios
      .get("static/data/dictionary")
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getHSProducts(importerID, callback) {
    axios
      .get(`static/data/hs/${importerID}`)
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },

  getHSProductsE(data, callback) {
    axios
      .get(`static/data/hsExport/${data.importerID}`, {
        params: data.data
      })
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getHSProductsNew(data, callback) {
    axios
      .get(`static/data/hs/${data.importerID}`, {
        params: data.data
      })
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getFtaData(callback) {
    axios
      .get("static/data/fta")
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getBatchData(callback) {
    axios
      .get("benefit/batch/list")
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getAreaData(callback) {
    axios
      .get("static/data/area")
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getIndex(callback) {
    axios
      .get("index")
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  sendSMS(mobile, rand, callback) {
    axios
      .get("common/sms", {
        params: {
          rand: rand || "register",
          mobile: mobile
        }
      })
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  sendMail(email, loginName, rand, callback) {
    axios
      .get("common/email", {
        params: {
          rand: rand || "forget_password",
          loginName: loginName,
          email: email
        }
      })
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  activationAccount(token, callback) {
    axios
      .get("common/activation", {
        params: { token: token }
      })
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  getSasToken(container, callback) {
    axios
      .get("common/blob/sas", {
        params: {
          container: container || "content"
        }
      })
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  upload(url, data, callback) {
    axios
      .post(url || "common/blob/upload", data, {
        headers: {
          "Content-Type": false
        },
        onUploadProgress: progressEvent => {
          if (progressEvent.lengthComputable) {
            let complete =
              (((progressEvent.loaded / progressEvent.total) * 100) | 0) + "%";
            if (callback && typeof callback.process == "function") {
              callback.process(complete);
            }
          }
        }
      })
      .then(function(response) {
        if (callback && typeof callback.success == "function") {
          callback.success(response);
        }
      })
      .catch(function(error) {
        if (callback && typeof callback.error == "function") {
          callback.error(error);
        }
      });
  },
  account: {
    login(data, callback) {
      axios
        .post("login", data)
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    logout(callback) {
      axios
        .get("logout")
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    register: {
      personal(data, callback) {
        axios
          .post("register/personal", data)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      enterprise(data, callback) {
        axios
          .post("register/enterprise", data)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      available(loginName, callback) {
        axios
          .get("register/name/available", {
            params: { loginName: loginName }
          })
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      }
    },
    chkPwd(data, callback) {
      axios
        .put("member/password", data)
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    forgotPwd(data, callback) {
      axios
        .put("member/password/forget", data)
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    member: {
      setting: {
        get(callback) {
          axios
            .get("member/setting")
            .then(function(response) {
              if (callback && typeof callback.success == "function") {
                callback.success(response);
              }
            })
            .catch(function(error) {
              if (callback && typeof callback.error == "function") {
                callback.error(error);
              }
            });
        },
        set(data, callback) {
          axios
            .put("member/setting", data)
            .then(function(response) {
              if (callback && typeof callback.success == "function") {
                callback.success(response);
              }
            })
            .catch(function(error) {
              if (callback && typeof callback.error == "function") {
                callback.error(error);
              }
            });
        }
      },
      get(callback) {
        axios
          .get("member")
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      updateMember(data, callback) {
        axios
          .put("member", data)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      home(callback) {
        axios
          .get("index")
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      apiQueryStat(data, callback) {
        axios
          .get("statistics/api/list", {
            params: data || {}
          })
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      recharge: {
        list(data, callback) {
          axios
            .get("package/list", {
              params: data || {}
            })
            .then(function(response) {
              if (callback && typeof callback.success == "function") {
                callback.success(response);
              }
            })
            .catch(function(error) {
              if (callback && typeof callback.error == "function") {
                callback.error(error);
              }
            });
        },
        get(id, callback) {
          axios
            .get(`package/${id}`)
            .then(function(response) {
              if (callback && typeof callback.success == "function") {
                callback.success(response);
              }
            })
            .catch(function(error) {
              if (callback && typeof callback.error == "function") {
                callback.error(error);
              }
            });
        },
        confirm(id, callback) {
          axios
            .get("recharge/confirm", {
              params: { packageId: id }
            })
            .then(function(response) {
              if (callback && typeof callback.success == "function") {
                callback.success(response);
              }
            })
            .catch(function(error) {
              if (callback && typeof callback.error == "function") {
                callback.error(error);
              }
            });
        },
        pay(data, callback) {
          axios
            .post("pay", data)
            .then(function(response) {
              if (callback && typeof callback.success == "function") {
                callback.success(response);
              }
            })
            .catch(function(error) {
              if (callback && typeof callback.error == "function") {
                callback.error(error);
              }
            });
        },
        payResult(id, callback) {
          axios
            .get(`pay/${id}`)
            .then(function(response) {
              if (callback && typeof callback.success == "function") {
                callback.success(response);
              }
            })
            .catch(function(error) {
              if (callback && typeof callback.error == "function") {
                callback.error(error);
              }
            });
        },
        history(data, callback) {
          axios
            .get("recharge/list", {
              params: data || {}
            })
            .then(function(response) {
              if (callback && typeof callback.success == "function") {
                callback.success(response);
              }
            })
            .catch(function(error) {
              if (callback && typeof callback.error == "function") {
                callback.error(error);
              }
            });
        }
      },
      integral: {
        history(data, callback) {
          axios
            .get("integral/list", {
              params: data || {}
            })
            .then(function(response) {
              if (callback && typeof callback.success == "function") {
                callback.success(response);
              }
            })
            .catch(function(error) {
              if (callback && typeof callback.error == "function") {
                callback.error(error);
              }
            });
        },
        card: {
          get(code, callback) {
            axios
              .get(`integral/card/${code}`)
              .then(function(response) {
                if (callback && typeof callback.success == "function") {
                  callback.success(response);
                }
              })
              .catch(function(error) {
                if (callback && typeof callback.error == "function") {
                  callback.error(error);
                }
              });
          },
          exchange(code, callback) {
            axios
              .post(`integral/card/${code}`)
              .then(function(response) {
                if (callback && typeof callback.success == "function") {
                  callback.success(response);
                }
              })
              .catch(function(error) {
                if (callback && typeof callback.error == "function") {
                  callback.error(error);
                }
              });
          },
          history(data, callback) {
            axios
              .get("integral/card/list", {
                params: data || {}
              })
              .then(function(response) {
                if (callback && typeof callback.success == "function") {
                  callback.success(response);
                }
              })
              .catch(function(error) {
                if (callback && typeof callback.error == "function") {
                  callback.error(error);
                }
              });
          }
        }
      },
      invoice: {
        list(data, callback) {
          axios
            .get("invoice/list", {
              params: data || {}
            })
            .then(function(response) {
              if (callback && typeof callback.success == "function") {
                callback.success(response);
              }
            })
            .catch(function(error) {
              if (callback && typeof callback.error == "function") {
                callback.error(error);
              }
            });
        },
        book(callback) {
          axios
            .get("invoice/book")
            .then(function(response) {
              if (callback && typeof callback.success == "function") {
                callback.success(response);
              }
            })
            .catch(function(error) {
              if (callback && typeof callback.error == "function") {
                callback.error(error);
              }
            });
        },
        applyInvoice(data, callback) {
          axios
            .post("invoice", data)
            .then(function(response) {
              if (callback && typeof callback.success == "function") {
                callback.success(response);
              }
            })
            .catch(function(error) {
              if (callback && typeof callback.error == "function") {
                callback.error(error);
              }
            });
        }
      }
    }
  },
  query: {
    getRcepSample(callback) {
      axios
        .get("/knowledge/getRcepSample", {
          params: {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    getKnowledgeFta(callback) {
      axios
        .get("/knowledge/getKnowledgeFta", {
          params: {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    knowledgeId(id, callback) {
      axios
        .get("knowledge/" + id, {
          params: {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    getKnowledgeNameByFtaId(ftaId, callback) {
      return axios.get("knowledge/getKnowledgeNameByFtaId", {
        params: { ftaId: ftaId }
      });
    },
    getKnowledgeNameByFtaId2(params, callback) {
      return axios.get("knowledge/getKnowledgeNameByFtaId", {
        params: params
      });
    },
    searchAnti2(exporterID, hsCode, page, callback) {
      return axios.get("search/tax/searchAnti", {
        params: {
          exporter: exporterID,
          hs: hsCode,
          page: page,
          size: 10
        }
      });
    },
    tax(importerID, exporterID, hsCode, callback) {
      axios
        .get("search/tax", {
          params: {
            importer: importerID,
            exporter: exporterID,
            hs: hsCode
          }
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    levy(importerID, exporterID, hsCode, type, callback) {
      axios
        .get("search/levy", {
          params: {
            importer: importerID,
            exporter: exporterID,
            hs: hsCode,
            type
          }
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    exportTax(importerID, exporterID, hsCode, callback) {
      axios
        .get("search/exportTax", {
          params: {
            importer: importerID,
            exporter: exporterID,
            hs: hsCode
          }
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    rule(importerID, exporterID, hsCode, callback) {
      axios
        .get("search/rule", {
          params: {
            importer: importerID,
            exporter: exporterID,
            hs: hsCode
          }
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    rule2(importerName, exporterName, hsCode, callback) {
      axios
        .get("search/rule", {
          params: {
            importerName: exporterName,
            exporterName: importerName,
            hs: hsCode
          }
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    hs(importerID, hsCode, callback) {
      axios
        .get("search/hs", {
          params: importerID
            ? {
                importer: importerID,
                hs: hsCode
              }
            : {
                hs: hsCode
              }
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    }
  },
  coo: {
    goods: {
      loseStatus(data, callback) {
        axios
          .post("ruling/goods/loseStatus", data)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      getProcessingProcedure(data, callback) {
        return axios.get("ruling/goods/getProcessingProcedure", {
          params: data || {}
        });
      },
      whollyObtained(data, callback) {
        axios
          .post("ruling/goods/determination/whollyObtained", data)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      getAdditional(data, callback) {
        axios
          .post("ruling/goods/origin/getAdditional", data)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      getAdditional2(data, callback) {
        return axios.post("ruling/goods/origin/getAdditional", data);
      },
      list(data, callback) {
        axios
          .get("ruling/goods/list", {
            params: data || {}
          })
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      get(id, callback) {
        axios
          .get(`ruling/goods/${id}`)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      add(data, callback) {
        axios
          .post("ruling/goods", data)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      save(id, data, callback) {
        axios
          .put(`ruling/goods/${id}`, data)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      del(id, callback) {
        axios
          .delete(`ruling/goods/${id}`)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      batchDel(ids, callback) {
        axios
          .post("ruling/goods/del/batch", { ids: ids })
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      uploadAttachment(id, data, callback) {
        axios
          .put(`ruling/determination/${id}/file`, data)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      }
    },
    determination: {
      get(id, callback) {
        axios
          .get(`ruling/goods/${id}/determination`)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      save(id, data, callback) {
        axios
          .put(`ruling/goods/${id}/determination`, data)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      submit(id, data, callback) {
        axios
          .post(`ruling/goods/${id}/determination`, data)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      determinationCountry(id, data, callback) {
        axios
          .post(`ruling/goods/determinationCountry/${id}`, data)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      archive(id, callback) {
        axios
          .post(`ruling/goods/${id}/lock`)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      detail(id, callback) {
        axios
          .get(`ruling/determination/${id}`)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      history(id, data, callback) {
        axios
          .get(`ruling/goods/${id}/determination/history`, {
            params: data || {}
          })
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      }
    },
    cert: {
      list(data, callback) {
        axios
          .get("ruling/cert/list", {
            params: data || {}
          })
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      get(id, callback) {
        axios
          .get(`ruling/cert/${id}`)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      invoiceList(data, callback) {
        // \u53d1\u7968\u5217\u8868
        axios
          .get("ruling/cert/invoice/list", {
            params: data || {}
          })
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      bookList(data, callback) {
        // \u8bc1\u4e66\u6750\u6599\u7c3f
        axios
          .get("ruling/cert/book/list", {
            params: data || {}
          })
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      confirm(data, callback) {
        // \u8bc1\u4e66\u4fe1\u606f\u786e\u8ba4
        axios
          .get("ruling/cert/confirm", {
            params: data || {}
          })
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      },
      create(data, callback) {
        //\u751f\u6210\u8bc1\u4e66
        axios
          .post("ruling/cert", data)
          .then(function(response) {
            if (callback && typeof callback.success == "function") {
              callback.success(response);
            }
          })
          .catch(function(error) {
            if (callback && typeof callback.error == "function") {
              callback.error(error);
            }
          });
      }
    }
  },
  batchQuery: {
    get(callback) {
      axios
        .get("batch")
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    submit(data, callback) {
      axios
        .post("batch", data)
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    }
  },
  notice: {
    get(id, callback) {
      axios
        .get(`/index/notice/${id}`)
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    }
  },
  news: {
    getList(data, callback) {
      axios
        .get("news/list", {
          params: data || {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    get(id, callback) {
      axios
        .get(`news/${id}`)
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    }
  },
  laws: {
    getList(data, callback) {
      axios
        .get("laws/list", {
          params: data || {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    get(id, callback) {
      axios
        .get(`laws/${id}`)
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    }
  },
  benefit: {
    getList(data, callback) {
      axios
        .get("benefit/list", {
          params: data || {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    get(id, callback) {
      axios
        .get(`benefit/${id}`)
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    getbenefitDetailList(data, callback) {
      axios
        .get(`benefit/detailList`, {
          params: data || {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    stat(callback) {
      axios
        .get("benefit/member")
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    stat2(data, callback) {
      axios
        .get("benefit/count", {
          params: data || {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    getAnalysis(callback) {
      axios
        .get("benefit/analysis/count")
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    export(data, callback) {
      axios
        .get("benefit/export", {
          params: data || {},
          responseType: "arraybuffer"
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    }
  },
  classify: {
    getList(data, callback) {
      axios
        .post("intelligentClassify/getHotWordQueryPage", data)
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },

    getclassifyDetail(data, callback) {
      axios
        .get(`intelligentClassify/getHotWordQueryDetail/` + data)
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    }
  },
  OnlineMessage: {
    getList(data, callback) {
      axios
        .get("member/leaveMsg/list", {
          params: data || {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    myList(data, callback) {
      axios
        .get("member/leaveMsg/myList", {
          params: data || {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    add(data, callback) {
      axios
        .post(`member/leaveMsg/add`, data)
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    },
    getdetail(no, callback) {
      axios
        .get(`member/leaveMsg/` + no)
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    }
  },
  faq: {
    getList(data, callback) {
      axios
        .get("faq/list", {
          params: data || {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    }
  },
  zmTariffQuery: {
    get(data, callback) {
      axios
        .get("dictionary/levy", {
          params: data || {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    }
  },
  codeQuery: {
    getList(data, callback) {
      axios
        .get("dictionary/hs", {
          params: data || {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    }
  },
  ciqQuery: {
    getList(data, callback) {
      axios
        .get("dictionary/ciq", {
          params: data || {}
        })
        .then(function(response) {
          if (callback && typeof callback.success == "function") {
            callback.success(response);
          }
        })
        .catch(function(error) {
          if (callback && typeof callback.error == "function") {
            callback.error(error);
          }
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/def.js